import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/null',
    name: 'null',
    // 申报列表详情-中转页面
    component: () => import( /* webpackChunkName: 'null' */ '@/views/taskList/null/null')
  },
  {
    path: '/declare',
    name: 'declare',
    // 申报列表
    component: () => import( /* webpackChunkName: 'declare' */ '@/views/taskList/declare/declare'),
  },
  {
    path: '/declareDetail',
    name: 'declareDetail',
    // 申报列表详情
    component: () => import( /* webpackChunkName: 'declaredetail' */ '@/views/taskList/declare/declareDetail')
  },
  {
    path: '/declareSum',
    name: 'declareSum',
    // 申报列表详情-汇总数据
    component: () => import( /* webpackChunkName: 'summaryData' */ '@/views/taskList/declare/declareSum/summaryData')
  },
  {
    path: '/refresh',
    name: 'refresh',
    // 计提列表详情-中转页面
    component: () => import( /* webpackChunkName: 'refresh' */ '@/views/taskList/null/refresh')
  },
  {
    path: '/provision',
    name: 'provision',
    // 计提列表
    component: () => import( /* webpackChunkName: 'provision' */ '@/views/taskList/provision/provision'),
  },
  {
    path: '/provisionDetail',
    name: 'provisionDetail',
    // 计提列表详情
    component: () => import( /* webpackChunkName: 'provisionDetail' */ '@/views/taskList/provision/provisionDetail')
  },
  {
    path: '/provisionSum',
    name: 'provisionSum',
    // 计提列表详情-汇总数据
    component: () => import( /* webpackChunkName: 'summaryData' */ '@/views/taskList/provision/provisionSum/summaryData')
  },
  {
    path: '/initialization',
    name: '初始化模板',
    // 初始化
    component: () => import( /* webpackChunkName: 'initialization' */ '@/views/initialization/initialization')
  },
  {
    path: '/taxapplworkbook',
    name: '适用模板配置',
    // 适用模板配置
    component: () => import( /* webpackChunkName: 'initialization' */ '@/views/initialization/taxapplworkbook')
  },
  {
    path: '/declarationform',
    name: '申报表档案',
    // 申报表档案
    component: () => import( /* webpackChunkName: 'declarationform' */ '@/views/archive/declarationform')
  },
  {
    path: '/ledgerTask',
    name: ' 台账任务列表',
    query: {
      id: 1
    },
    // 台账任务列表
    component: () => import( /* webpackChunkName: 'ledgerTask' */ '@/views/taskList/ledger/ledger')
  },
  {
    path: '/ledgerTemplate',
    name: '台账模板管理',
    // 台账模板管理
    component: () => import( /* webpackChunkName: 'ledgerTemplate' */ '@/views/template/ledgerTemplate')
  },
  {
    path: '/baseDataMaintain',
    name: '常用项取数维护',
    // 常用项取数维护
    component: () => import( /* webpackChunkName: 'baseDataMaintain' */ '@/views/baseData/baseDataMaintain')
  },
  {
    path: '/defineReportTemplate',
    name: '自定义报表管理',
    // 自定义报表管理
    component: () => import( /* webpackChunkName: 'defineReportTemplate' */ '@/views/template/defineReportTemplate')
  },
  {
    path: '/provisionTemplate',
    name: '计提模板管理',
    // 计提模板管理
    component: () => import( /* webpackChunkName: 'provisionTemplate' */ '@/views/template/provisionTemplate')
  },
  {
    path: '/reportTemplate',
    name: '申报模板管理',
    // 申报模板管理
    component: () => import( /* webpackChunkName: 'reportTemplate' */ '@/views/template/reportTemplate')
  },
  {
    path: '/offplatformDataPenetra',
    name: '',
    // 数据穿透-标准数据
    component: () => import( /* webpackChunkName: 'declare' */ '@/views/taskList/dataPenetra/offplatformDataPenetra')
  },
  {
    path: '/offplatformDataPenetraTarget',
    name: '',
    // 数据穿透-企业数据
    component: () => import( /* webpackChunkName: 'declare' */ '@/views/taskList/dataPenetra/offplatformDataPenetraTarget')
  },
  {
    path: '/platformDataPenetra',
    name: '',
    // 数据穿透-平台表数据穿透(底稿、申报表、计提、台账)
    component: () => import( /* webpackChunkName: 'declare' */ '@/views/taskList/dataPenetra/platformDataPenetra')
  },
  {
    path: '/auditDataimport',
    name: '事务所审核数据导入',
    // 事务所审核数据导入
    component: () => import( /* webpackChunkName: 'declare' */ '@/views/taskList/auditDataimport/auditDataimport')
  },
  {
    path: '/varianceAnalysis',
    name: '差异分析报告',
    // 差异分析报告
    component: () => import( /* webpackChunkName: 'declare' */ '@/views/taskList/varianceAnalysis/varianceAnalysis')
  },
  {
    path: '/delayManage',
    name: '税金延期管理',
    // 税金延期管理
    component: () => import( /* webpackChunkName: 'delayManage' */ '@/views/taxes/taxDelayManage/delayManage')
  },
  {
    path: '/delayDetail',
    name: 'delayDetail',
    // 延期详情/延期更新
    component: () => import( /* webpackChunkName: 'delayDetail' */ '@/views/taxes/taxDelayManage/delayDetail')
  },
  {
    path: '/fundPlan',
    name: 'fundPlan',
    // 税款资金计划
    component: () => import( /* webpackChunkName: 'fundPlan' */ '@/views/taxes/taxFundPlan/fundPlan')
  },
  {
    path: '/fundDetail',
    name: 'fundDetail',
    // 资金详情/资金更新
    component: () => import( /* webpackChunkName: 'fundDetail' */ '@/views/taxes/taxFundPlan/fundDetail')
  },
  {
    path: '/executeManage',
    name: 'executeManage',
    // 税金执行管理
    component: () => import( /* webpackChunkName: 'executeManage' */ '@/views/taxes/taxExecuteManage/executeManage')
  },
  {
    path: '/executeDetail',
    name: 'executeDetail',
    // 执行详情/执行更新
    component: () => import( /* webpackChunkName: 'executeDetail' */ '@/views/taxes/taxExecuteManage/executeDetail')
  },
  {
    //自定义统计
    path: '/defineStatistics',
    name: '自定义统计',
    component: resolve => require(['@/views/taskList/defineStatistics/define/defineStatistics'], resolve),
  },
  {
    //资产明细表
    path: '/assetTable',
    name: '资产明细表',
    component: () => import( /* webpackChunkName: 'assetTable' */ '@/views/assetDetails/assetTable')
  },
  {
    //税金统计表
    path: '/taxStatisticsTemplate',
    name: 'taxStatisticsTemplate',
    component: () => import( /* webpackChunkName: 'taxStatisticsTemplate' */ '@/views/template/taxStatisticsTemplate')
  },
  ]
})

router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
  document.title = to.name
  next() //执行进入路由，如果不写就不会进入目标页
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js